import _ from '@lodash';
import React, { useState, useEffect, useRef } from 'react';
import axios from "@fuse/utils/axios";
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Button, Tooltip } from '@material-ui/core';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import { useDispatch, useSelector } from 'react-redux';
import useRouter from '@fuse/hooks/useRouter';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import { formatString } from '@fuse/utils/stringOperations';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import useToast from '@fuse/hooks/useToast';
import { usePermission } from '@fuse/hooks';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';

const useStyles = makeStyles({
	layoutRoot: {},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin: '5px 5px 5px 0',
		height: '28px'
	},
	buttonSquare: {
		borderRadius: '5px'
	},
	cardGen: {
		width: '20%',
		height: "100%"
		// border:"1px solid red"
	},
	btn: {
		background: "#30C90A",
		// width:"120px",
		borderRadius: "17px",
		color: "#fff"
	},
	activeTab: {
		// borderBottom: "2px solid",
		// borderBottomLeftRadius: "0px !important",
		// borderBottomRightRadius: "0px !important",
		background: "rgba(107, 44, 87, 0.04);",
		borderRadius: "0",
	}
});

function TabButton(props) {
	const { activeClass, tab, tabState, tabStateChange, ...restProps } = props;
	const isActive = tab == tabState;

	return (
		<Button
			{...restProps}
			onClick={() => tabStateChange(tab)}
			className={restProps.className && isActive ? activeClass : ""}>
			{props.children}
		</Button>
	)
}

function TabContainer(props) {
	const { tabState, tab } = props;
	const shouldRender = tab == tabState;
	return shouldRender ? props.children : <></>
}

function ListView(props) {
	const classes = useStyles();
	const [gridApi, setGridApi] = useState(null);
	// const rowGroupPanelShow = 'always';
	const table_name = "contractsArchiveApp";
	const [tabState, setTabState] = useState("details");
	const [displayButton, setDisplayButton] = useState(false);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const [contractDetails, setContractDetails] = useState(null)
	const dispatch = useDispatch();
	const router = useRouter();
	const toast = useToast(dispatch)
	const gridRef = useRef();
	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');
	const [groupByArr, setGroupByArr] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const { hasPermission } = usePermission()
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const viewContractPermission = hasPermission('view-contract', true)
	const [filterApplied, setFilterApplied] = useState(false);

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleClickOpen = (data) => {
		// setContractDetails(data)
		router.push(`/archived-contracts/${data.id}`)
		// dispatch(setContractId(null));
	};

	const Close = () => {
		setContractDetails(false)
		setOpen(false);
		setTabState('details')
	};

	function setHeaderName(header) {
		if (header == 'contract_id') {
			return 'Contract ID'
		} if (header == 'shipping_id') {
			return 'Shipping ID'
		} if (header == 'billing_id') {
			return 'Billing ID'
		} if (header == 'client_users_id') {
			return 'Client User ID'
		} if (header === "contract_name") {
			return 'Contract';
		} 
			return header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
		
	}

	const handelEdit = (data) => {
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	const handleClose = () => {
		setContractDetails(null)
	}

	const handleConfirm = (data) => {
		setContractDetails(data)
	}

	const handleUnarchive = () => {
		axios.get(`/contracts/unarchive-contract/${contractDetails?.id}`).then(res => {
			toast.success('Contract restored successfully. Open Contract Listing to view')
			props.refresh()
		}).catch(err => {
			toast.error('Something went wrong')
		})
	}

	const onKeyUp = (event) => {
		const searchItem = event.target.value;
		gridApi.api.setQuickFilter(searchItem);
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	function onColumnVisible(params) {
		const rows = params.api?.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name == undefined) {
				saveView(rows);
			}
		}
	}
	function onSortChanged(params) {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}
	useEffect(() => {
		if (router.params?.id) {
			handleClickOpen({ id: router.params.id })
		}
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [props.endUsersAccounts])

	const onGridSizeChanged = (params) => {
		// setWindowHeight(window.innerHeight - 330);
	}

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	const clearSelection = () => {
		gridApi.api.clearRangeSelection();
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// stop rerender to show no overlay text
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
    if (!api) return;
    const groupedColumns = api.getRowGroupColumns();
    if (groupedColumns.length === 0) setGroupByArr([]);
    else setGroupByArr(groupedColumns);
		if (router.query.report_name == undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
	}

	function getReport(event) {
		const {report_name} = router.query;
		const table_name = "contractsArchiveApp";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event.api?.getColumnState(row_model);
			})
			.catch(err => {
				console.log(err);
			})
	}

	function saveView(rows, filter) {
		let payload = {}
		if (rows == 'N/A') {
			payload = {
				filter: JSON.stringify(filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onGridReady = (params) => {
		gridRef.current = params;
		setGridApi(params);
		props.endUsersAccounts.forEach((list) => {
			for (const [fieldName, value] of Object.entries(list)) {
				if (value === '-') list[fieldName] = `No ${formatString(fieldName)}`
			}
		})
		if (router.query.report_name == undefined) {
			loadInitialState(params)
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		} else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}

	useEffect(() => {
		gridRef.current.api?.setQuickFilter(query_data);
	}, [query_data])


	function loadInitialState(params) {
		axios
			.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then((results) => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api?.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (filter && Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	// function onRowGroupOpenedAutoSize(){
	// 	const allColumnIds = [];
	// 	gridApi.api.getColumnState().forEach((column) => {
	// 		// only auto-sizing the auto-generated group column
	// 		if(column.colId === 'ag-Grid-AutoColumn') {
	// 			allColumnIds.push(column.colId);
	// 		}
	// 	});
	// 	gridApi.columnApi.autoSizeColumns(allColumnIds, false);
	// }

	const headersNotToBeListed = [
		'id', 'contract_status_object', 'parent_contract_object', /* 'company_name',*/'contract_description',
		'service_level_agreement_object', 'service_provider_object', 'contract_type_object',
		'location_id', 'location_object', 'contract_payment_object', 'master_object', "source", "payment_order_date",
		'payment_amount', "currency", "payment_term", "payment_order_number", "reminder", "text_contact_number", "status"
	]

	return (
		<>
			<AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="Archived Contract"
				displayTableName="Archived Contracts"
			/>
			<div className="ag-theme-alpine" style={{ width: "100%", height: windowHeight + 165, fontSize: '12px' }}>
				<AgGridReact
					ref={gridRef}
					theme='legacy'
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					// autoGroupColumnDef={{ minWidth: 500 }}
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					// headerHeight = {15}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					pagination
					components={frameworkComponents}
					columnDefs={[
						// ✅ Actions Column
						{
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							lockPosition: true,
							width: 120,
							minWidth: 120,
							maxWidth: 120,
							pinned: "right",
							lockPinned: true,
							suppressSizeToFit: true,
							cellRenderer: ({ data }) => {
								if (!data) return null;

								return (
									<>
										{props.viewContractPermission && (
											<Tooltip id="view" title="View" placement="top">
												<Icon
													onMouseDown={() => handleClickOpen(data)}
													style={{
														color: "#1d2939",
														paddingBottom: "3px",
														paddingRight: "30px",
														fontSize: "15px",
														cursor: "pointer",
													}}
												>
													visibility
												</Icon>
											</Tooltip>
										)}
									</>
								);
							},
						},

						// ✅ Dynamic Columns
						...Object.keys(props.endUsersAccounts[0])
							.filter((header) => !headersNotToBeListed.includes(header))
							.map((header) => {
								const baseCol = {
									field: header,
									flex: 1,
									minWidth: 200,
									sortable: true,
									filter: "agTextColumnFilter",
									headerComponent: (props) => CustomFilter(props, header, gridRef),
								};

								if (header === "shipping_id") {
									return {
										...baseCol,
										headerName: "Location",
									};
								}

								if (
									header === "contract_start_date" ||
									header === "contract_end_date"
								) {
									return {
										...baseCol,
										headerName: setHeaderName(header),
									};
								}

								return {
									...baseCol,
									headerName: setHeaderName(header),
								};
							}),
					]
					}
				 />
				<GeneralModal
					open={contractDetails}
					title="Restore Contract"
					text={<h4>Are you sure to restore this Contract named as <b>{contractDetails?.contract_name}</b>?</h4>}
					handleClose={handleClose}
					handleConfirm={handleUnarchive}
					actionButtonName="Restore"
				/>
			</div>
		</>
	);
}

export default ListView
